import { render, staticRenderFns } from "./deduplica.vue?vue&type=template&id=8ec49b94"
import script from "./deduplica.vue?vue&type=script&lang=ts"
export * from "./deduplica.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports